import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils.js"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0" +
  " hover-elevate active-elevate-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground border border-transparent shadow shadow-primary/20 hover:shadow-glow hover:bg-primary/90 transition-all duration-300 ease-out",
        destructive:
          "bg-destructive text-destructive-foreground border border-transparent hover:bg-destructive/90 transition-all duration-300",
        outline:
          "border [border-color:var(--button-outline)] bg-transparent hover:bg-accent hover:text-accent-foreground backdrop-blur-sm transition-all duration-300 ease-out",
        secondary:
          "border border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 transition-all duration-300",
        ghost:
          "border border-transparent hover:bg-accent hover:text-accent-foreground transition-all duration-300",
      },
      size: {
        default: "min-h-9 px-4 py-2",
        sm: "min-h-8 rounded-md px-3 text-xs",
        lg: "min-h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
